<template lang="pug">
  #app
    transition(name="slide")
      Menu(v-if="menu" @interruptor="modales") 
    header.fondo-gris-claro.letra-morada-oscura
      router-link(to="/", v-if="$route.path !== '/'")
        img(alt="Logo Ellas Libres de Violencias", src="@/assets/LogoEllas.svg", height="60")
      input(type="checkbox", id="burger", v-model="menu")
      label(for="burger")
        span.bar.top
        span.bar.middle
        span.bar.bottom
      Autocompletar
    transition(name="fade")
      router-view(:municipio="municipio" @interruptor="modales")
    Pie
    Modal(:visible.sync="uno").orientacion
      ModalEmergencias(:data="data[0].contenido")    
    LineasOrientacion(:visible.sync="dos") 
    
      
            

</template>

<script>
import Autocompletar from './components/Autocompletar.vue'
import Cabecera from './components/Cabecera.vue'
import Menu from './components/Menu.vue'
import Inicio from './paginas/Inicio.vue'
import Pie from '@/components/Pie.vue' 
import Modal from "@/components/Modal.vue"
import LineasOrientacion from "@/components/LineasOrientacion" 
import ModalEmergencias from "@/components/ModalEmergencias" 

export default {
  name: 'app',
  data() {
    return {
      menu: false,
      dos: false,
      uno: false,
      data: []
    }
  },
  mounted() {
    if (localStorage.municipio) {
      this.$store.commit("cambiaMunicipio", JSON.parse(localStorage.municipio)) 
    }
  },
  watch: {
    municipio(nuevo) {
      localStorage.municipio = JSON.stringify(nuevo)
    },
    '$route' () {
      window.scrollTo(0, 0)
      this.menu = false
    }
  },
  components: {
    Autocompletar,
    Modal,
    Cabecera,
    Menu,
    Inicio,
    Pie,
    LineasOrientacion,
    ModalEmergencias
  },
  computed: {
    municipio() {
      return this.$store.state.municipio
    }
  },
  methods: {
    getContent () {
      this.$prismic.client.getSingle('acciones_inicio')
        .then((response) => {
          this.data = response.data.acciones
      })
    },
    modales(n) {
      if(n==1) {
        this.uno = true
      } else {
        this.dos = true
      }
      this.menu = false
    }
  },
  created() {
        this.getContent();
  }
}
</script>

<style lang="sass">
@import "./sass/_global"
@import "./sass/celular/_global"
header
  a 
    background: $morado-ellas  
    height: 70px
    width: 70px
    box-sizing: border-box
    display: flex
    align-items: center
    justify-content: center
</style>
